<template>
<div id="informacion_activo_fijo" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12" >
        <base-material-card color="primary" icon="library_books" title="Información de Contenido en Pedimentos" class="elevation-1 px-5 py-3" >
          <br>
          <v-tabs grow style="margin-bottom: 30px;" >
            <v-tabs-slider color="primary" ></v-tabs-slider>
            <v-tab key="reportesGlobal" @click="tipo=1;" >Reporte de valor global por pedimento</v-tab>
            <v-tab key="reportesPartida" @click="tipo=2;" >Reporte por secuencia de fracción</v-tab>
            <v-tab key="reporteCoves" @click="tipo=3;" >Reporte Por Factura-COVE</v-tab>            

            <v-tab-item key="reportesGlobal" >
              <div class="contenedor-tab-reportes" >
                <v-card-text>
                  <v-card-title>
                    <span class="headline" ></span>
                  </v-card-title>
                  <v-form ref="form" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                      <v-row row wrap>
                      <v-col sm="3" md="3" lg="3">
                        <v-autocomplete v-model="model.tipo_reporte" :items="tipos" 
                          :hide-no-data="true" :return-object="false" item-text="text" item-value="id" 
                          label="Filtrar Por" @change="clear_values()" :rules="[rules.required]" >
                        </v-autocomplete>
                      </v-col>
                      <v-col sm="3" md="3" lg="3">
                        <v-switch
                        v-model="model.no_af"
                          :true-value="1" :false-value="0"
                          color="red darken-3"
                          label="Solo NO_AF"
                      ></v-switch>
                      </v-col>
                      <v-col sm="6" md="6" lg="6">
                        <v-layout row wrap>
                          <v-flex>                            
                            <v-switch color="primary" label="Importación" v-model="model.opc_impo" :true-value="1" :false-value="0" :rules="[verificaTipoOperacion]"></v-switch>
                          </v-flex>
                          <v-flex>                            
                            <v-switch color="primary" label="Exportación" :true-value="1" :false-value="0" v-model="model.opc_expo"></v-switch>
                          </v-flex>
                        </v-layout>
                      </v-col>
                    </v-row>

                    <v-row v-if="model.tipo_reporte == 2" row wrap>
                      <v-col cols="10" >
                        <v-text-field v-model="model.pedimento" label="Pedimento" prepend-icon="fa-search" 
                          :rules="[rules.required, validaPedimento]" ></v-text-field>
                      </v-col>
                      <v-col cols="2" >
                        <v-btn icon title="Pegar Listado" @click="listado=''; dialog1 = !dialog1" v-tippy>
                          <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                      <v-row v-if="model.tipo_reporte == 1" row wrap>
                        <v-col sm="12" md="6" lg="6" >
                          <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                                  :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" ></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu1 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col sm="12" md="6" lg="6" >
                          <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'"
                                  :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" ></v-text-field>
                            </template>
                            <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu2 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>

                        </v-col>
                      </v-row>
                    </v-container>

                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="success" @click="generar_reporte_sqs(0)" >
                    <v-icon>done</v-icon>Generar Reporte
                  </v-btn>
                </v-card-actions>
                <v-card-text>
                  <v-refresh-button :funcion="cargarReportes" />
                  <v-client-table ref="vuetable" :data="datos.reportes" :columns="columns_reportes" :options="options_reportes" class="elevation-1 pa-2" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>

                    <template slot="actions" slot-scope="props" >
                      <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)" >
                        <v-icon dark>get_app</v-icon>
                      </v-btn>
                      <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                    </template>
                  </v-client-table>
                </v-card-text>
              </div>
            </v-tab-item>
            <v-tab-item key="reportesPartida" >
              <div class="contenedor-tab-diaria" >
                <v-card-text>
                  <v-card-title>
                    <span class="headline" ></span>
                  </v-card-title>
                  <v-form ref="form" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                      <v-row row wrap>
                      <v-col sm="3" md="3" lg="3">
                        <v-autocomplete v-model="model.tipo_reporte" :items="tipos" 
                          :hide-no-data="true" :return-object="false" item-text="text" item-value="id" 
                          label="Filtrar Por" @change="clear_values()" :rules="[rules.required]" >
                        </v-autocomplete>
                      </v-col>
                      <v-col sm="3" md="3" lg="3">
                        <v-switch
                        v-model="model.no_af"
                          :true-value="1" :false-value="0"
                          color="red darken-3"
                          label="Solo NO_AF"
                      ></v-switch>
                      </v-col>
                      <v-col sm="6" md="6" lg="6">
                        <v-layout row wrap>
                          <v-flex>                            
                            <v-switch color="primary" label="Importación" v-model="model.opc_impo" :true-value="1" :false-value="0" :rules="[verificaTipoOperacion]"></v-switch>
                          </v-flex>
                          <v-flex>                            
                            <v-switch color="primary" label="Exportación" :true-value="1" :false-value="0" v-model="model.opc_expo"></v-switch>
                          </v-flex>
                        </v-layout>
                      </v-col>
                    </v-row>

                    <v-row v-if="model.tipo_reporte == 2" row wrap>
                      <v-col cols="10" >
                        <v-text-field v-model="model.pedimento" label="Pedimento" prepend-icon="fa-search" 
                          :rules="[rules.required, validaPedimento]" ></v-text-field>
                      </v-col>
                      <v-col cols="2" >
                        <v-btn icon title="Pegar Listado" @click="listado=''; dialog1 = !dialog1" v-tippy>
                          <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                      <v-row v-if="model.tipo_reporte == 1" row wrap>
                        <v-col sm="12" md="6" lg="6" >
                          <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)"
                                  v-mask="'####-##-##'" :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" ></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu3 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu3 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col sm="12" md="6" lg="6" >
                          <v-menu offset-x ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'"
                                  :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" ></v-text-field>
                            </template>
                            <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu4 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu4 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>

                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="success" @click="generar_reporte_sqs(0)" >
                    <v-icon>done</v-icon>Generar Reporte
                  </v-btn>
                </v-card-actions>
                <v-card-text>
                  <v-refresh-button :funcion="cargarReportesPartida" />
                  <v-client-table ref="vuetable" :data="datos.reportesPartidas" :columns="columns_reportes" :options="options_reportes" class="elevation-1 pa-2" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>

                    <template slot="actions" slot-scope="props" >
                      <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)" >
                        <v-icon dark>get_app</v-icon>
                      </v-btn>
                      <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                    </template>
                  </v-client-table>
                </v-card-text>
              </div>
            </v-tab-item>
            <v-tab-item key="reporteCoves" >    
              <div class="contenedor-tab-diaria" >
                <v-card-text>
                  <v-card-title>
                    <span class="headline" ></span>
                  </v-card-title>
                  <v-form ref="form" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                      <v-row row wrap>
                      <v-col sm="6" md="6" lg="6">
                        <v-autocomplete v-model="model.tipo_reporte" :items="tipos" 
                          :hide-no-data="true" :return-object="false" item-text="text" item-value="id" 
                          label="Filtrar Por" @change="clear_values()" :rules="[rules.required]" >
                        </v-autocomplete>
                      </v-col>
                      <v-col sm="6" md="6" lg="6">
                        <v-layout row wrap>
                          <v-flex>                            
                            <v-switch color="primary" label="Importación" v-model="model.opc_impo" :true-value="1" :false-value="0" :rules="[verificaTipoOperacion]"></v-switch>
                          </v-flex>
                          <v-flex>                            
                            <v-switch color="primary" label="Exportación" :true-value="1" :false-value="0" v-model="model.opc_expo"></v-switch>
                          </v-flex>
                        </v-layout>
                      </v-col>
                    </v-row>
                    <v-row v-if="model.tipo_reporte == 2" row wrap>
                      <v-col cols="10" >
                        <v-text-field v-model="model.pedimento" label="Pedimento" prepend-icon="fa-search" 
                          :rules="[rules.required, validaPedimento]" ></v-text-field>
                      </v-col>
                      <v-col cols="2" >
                        <v-btn icon title="Pegar Listado" @click="listado=''; dialog1 = !dialog1" v-tippy>
                          <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                      <v-row v-if="model.tipo_reporte == 1" row wrap>
                        <v-col sm="12" md="6" lg="6" >
                          <v-menu offset-x ref="menu5" v-model="menu5" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)"
                                  v-mask="'####-##-##'" :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" ></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu5 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu5 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col sm="12" md="6" lg="6" >
                          <v-menu offset-x ref="menu6" v-model="menu6" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'"
                                  :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" ></v-text-field>
                            </template>
                            <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu6 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu6 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>

                        </v-col>
                      </v-row>  
                      <v-row>
                        <v-col sm="12" md="6" lg="6">
                          <v-text-field v-model="model.cove" label="COVE o Factura" clearable ></v-text-field>
                        </v-col>
                        <v-col sm="12" md="6" lg="6">
                          <v-text-field v-model="model.emisor" label="Nombre de Emisor/Destinatario" clearable ></v-text-field>
                        </v-col>                  
                      </v-row>                    
                    </v-container>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="success" @click="generar_reporte_sqs(0)" >
                    <v-icon>done</v-icon>Generar Reporte
                  </v-btn>
                </v-card-actions>
                <v-card-text>
                  <v-refresh-button :funcion="cargarReportesCoves" />
                  <v-client-table ref="vuetable" :data="datos.reportesCoves" :columns="columns_reportes" :options="options_reportes" class="elevation-1 pa-2" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                    </template>

                    <template slot="actions" slot-scope="props" >
                      <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)" >
                        <v-icon dark>get_app</v-icon>
                      </v-btn>
                      <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                    </template>
                  </v-client-table>
                </v-card-text>
              </div>
            </v-tab-item>            

          </v-tabs>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>

  <v-dialog v-model="dialog1" max-width="500px" >
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de pedimentos</h5>
        <span>Uno por línea</span>
        <v-form ref="formListado" lazy-validation="" >
          <v-textarea outlined rows="15" v-model="listado" :rules="[validaListado]" ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="listado=''; dialog1 = false" >Cancelar</v-btn>
        <v-btn small color="primary" @click="generaReporteListado()" >Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import RefreshButton from "@/components/RefreshButton.vue";
export default {
  components: {
    "v-refresh-button": RefreshButton,
  },
  created: function() {
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
      this.permisoEliminar = true;
    }
    this.URL = this.$hostname + "reportes_ws/";
    this.loading = false;
    this.rfc = this.$local_storage.get("rfc");
    this.tipo = 1;
    this.model.usuario = this.$local_storage.get("id_usuario");
    this.model.rfc = this.$local_storage.get("rfc");
    this.cargarReportesCoves();
    this.cargarReportes();
    this.cargarReportesPartida();
  },
  computed: {
  },
  data: () => ({
    listado:"",
    dialog1:false,
    tipos: [{
        "id": 1,
        "text": "Por Fechas de Pedimento"
      }, {
        "id": 2,
        "text": "Por Pedimento | Listado de Pedimentos"
      },
    ],
    fab: false,
    rfc: '',
    tipo: '',
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
          text: "Información de Contenido de Pedimentos",
          disabled: true,
          to: ""
      },
      {
          text: "Interfaz de Identificación AF_FILE",
          disabled: false,
          to: "/reportes/layouts_activofijo"
      },
      {
          text: "Reporte Activo Fijo",
          disabled: false,
          to: "/reportes/activofijo"
      },      
      {
          text: "Etiquetado Código QR",
          disabled: false,
          to: "/reportes/etiquetas_activofijo"
      }
    ],
    datos: {
      reportes: [],
      reportesPartidas: [],
      reportesCoves: [],
    },
    columns_reportes: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
    options_reportes: {
      filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
      sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

      headings: {
        id: "No. Proceso",
        fecha_solicitud: "Solicitado",
        usuario_email: "Usuario",
        nombre_reporte: "Reporte",
        criterio: "Criterio de Búsqueda",
        fecha_generacion: "Generado",
        estatus: "Estatus",
        error: "Error",
        actions: "Descargar"
      }
    },
    loading: false,
    show_loading: true,
    model: {
      rfc: "",
      usuario: "",
      pedimento:"",
      fecha_de: "",
      fecha_a: "",
      reporte_url: "",
      nombre_reporte: "",
      tipo: "Roce_ActivoFijo",
      opc_impo: 1,
      opc_expo: 1,
      opc_descripcion: 1,
      tipo_reporte: 1,
      no_af:0,
      cove:"",
      emisor:""
    },

    selecciona_todo8: false,
    selecciona_todo8_partida: false,
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
  }),
  methods: {
    clear_values() {
      this.model.pedimento = '';
      this.model.fecha_de = '';
      this.model.fecha_a = '';      
      this.listado = "";
    },
    validaPedimento: function() {
      if (this.model.pedimento != "") {
        if (!this.validarPatronPedimento(this.model.pedimento))
          return "Pedimento no válido. Ejemplo: 240-0123-0000123";
      }
      return true;
    },
    validarPatronPedimento(pedimento) {
      const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
      return patternPedimento.test(pedimento);
    },
    validaListado: function() {
      var listadoSinEspacios = this.removerLineasVacias(this.listado);
      if (listadoSinEspacios.length == 0) {
        return "Ingrese al menos 1 pedimento. Favor de verificar.";
      } else if (listadoSinEspacios.length > 250) {
        return "No se puede consultar mas de 250 pedimentos";
      } else {
        for (var k in listadoSinEspacios) {
          if (!this.validarPatronPedimento(listadoSinEspacios[k]))
            return "Verificar pedimentos no válidos. Ejemplo: 240-0123-0000123";
        }
      }

      return true;
    },
    removerLineasVacias(listado) {
      var listadoSplit = this.listado.split("\n");
      var listadoSinEspacios = listadoSplit.filter(item => {
        return item.trim() != "";
      });
      return listadoSinEspacios;
    },
    generaReporteListado() {      
      if (this.$refs.formListado.validate()) {        
        this.generar_reporte_sqs(1);
        this.dialog1 = false;        
      }
    },
    verificaTipoOperacion: function() {
      if (this.model.opc_impo != 1 && this.model.opc_expo != 1) {
        return "Seleccione al menos un tipo de operación";
      }
      return true;
    },
    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."
      else
        return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    downloadFile: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    generar_reporte_sqs(opcion=0) {      
      if (!this.$refs.form.validate() && opcion == 0) {        
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        if (this.tipo == 1){
          this.model.tipo = "Roce_ActivoFijo";
          this.model.reporte_url = "/reportes_ws/roce_activo_fijo/";
          this.model.nombre_reporte = "Activo Fijo por Pedimento";
        } else if (this.tipo == 2){
          this.model.tipo = "Pref_Arancelarias_ActivoFijo";
          this.model.reporte_url = "/reportes_ws/pref_arancelarias_activo_fijo/";
          this.model.nombre_reporte = "Activo Fijo por Partida";
        } else {
          this.model.tipo = "Reporte_CovePedimento";
          this.model.reporte_url = "/reportes_ws/rpt_coves_activo_fijo/";
          this.model.nombre_reporte = "Reporte Cove Pedimento";
        }
        var data = Vue.util.extend({}, this.model); //Clonamos el modelo

        if(opcion == 1){
          data["lista"] = this.removerLineasVacias(this.listado);
          data.pedimento = '';
        } 
        if (data.pedimento == '') delete(data['pedimento']);
        if (data.fecha_de == '') delete(data['fecha_de']);
        if (data.fecha_a == '') delete(data['fecha_a']);
        if (data.cove == null || data.cove == undefined) delete(data['cove']);
        if (data.emisor == null || data.emisor == undefined) delete(data['emisor']);        

        axios({
            method: "post",
            url: this.$hostname + "reportes/save_reporte/",            
            data: data
          })
          .then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
              footer: ""
            });
          })
          .catch(error => {
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
              if (error.response.status == 406) {
                titulo = "¡Ya existe un reporte en proceso!";
                tipo = "info";
              }
            } else {
              mensaje = "Ocurrió un error al generar el reporte";
            }
            this.$swal({
              type: tipo,
              title: titulo,
              text: mensaje,
              footer: ""
            });
          }).then(() => {
            this.cargarReportes();
            this.cargarReportesPartida();
            this.cargarReportesCoves();
            this.$root.$dialogLoader.hide();
          });
      }
    },
    cargarReportes: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        "tipo": "Roce_ActivoFijo"
      };
      axios.post(this.$hostname + "reportes/get_reportes/", data)
        .then(res => {
          if (res.data != undefined) {
            this.datos.reportes = res.data;
            this.datos.reportes.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud);
            });
            for (var k in this.datos.reportes) {
              this.datos.reportes[k].fecha_solicitud = this.parseDate(this.datos.reportes[k].fecha_solicitud);
              this.datos.reportes[k].fecha_generacion = this.parseDate(this.datos.reportes[k].fecha_generacion);
              this.datos.reportes[k].estatus = this.getEstatus(this.datos.reportes[k].estatus);
              this.datos.reportes[k].criterio = this.getCriterioPredeterminadosDS(this.datos.reportes[k].criterio);
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los reportes.",
            footer: ""
          });
          console.log(err);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    cargarReportesPartida: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        "tipo": "Pref_Arancelarias_ActivoFijo"
      };
      axios.post(this.$hostname + "reportes/get_reportes/", data)
        .then(res => {
          if (res.data != undefined) {
            this.datos.reportesPartidas = res.data;
            this.datos.reportesPartidas.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
            });
            for (var k in this.datos.reportesPartidas) {
              this.datos.reportesPartidas[k].fecha_solicitud = this.parseDate(this.datos.reportesPartidas[k].fecha_solicitud);
              this.datos.reportesPartidas[k].fecha_generacion = this.parseDate(this.datos.reportesPartidas[k].fecha_generacion);
              this.datos.reportesPartidas[k].estatus = this.getEstatus(this.datos.reportesPartidas[k].estatus);
              this.datos.reportesPartidas[k].criterio = this.getCriterioPredeterminadosDS(this.datos.reportesPartidas[k].criterio);
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los reportes.",
            footer: ""
          });
          console.log(err);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    cargarReportesCoves: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        "tipo": "Reporte_CovePedimento"
      };
      axios.post(this.$hostname + "reportes/get_reportes/", data)
        .then(res => {
          if (res.data != undefined) {
            this.datos.reportesCoves = res.data;
            this.datos.reportesCoves.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
            });
            for (var k in this.datos.reportesCoves) {
              this.datos.reportesCoves[k].fecha_solicitud = this.parseDate(this.datos.reportesCoves[k].fecha_solicitud);
              this.datos.reportesCoves[k].fecha_generacion = this.parseDate(this.datos.reportesCoves[k].fecha_generacion);
              this.datos.reportesCoves[k].estatus = this.getEstatus(this.datos.reportesCoves[k].estatus);
              this.datos.reportesCoves[k].criterio = this.getCriterioPredeterminadosDS(this.datos.reportesCoves[k].criterio);
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los reportes de Coves.",
            footer: ""
          });
          console.log(err);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    getCriterioPredeterminadosDS: function(criterio) {
      try {
        if (criterio != undefined && criterio.toString().trim() != "") {
          var params = JSON.parse(criterio);
          if(params.fecha_de && params.fecha_de!="")
            return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
          else if(params.lista && params.lista.length)
            return "Búsqueda por listado";
          else if(params.pedimento && params.pedimento!="")
            return "Pedimento: "+params.pedimento;          
        } else {
          return "N/A";
        }
      } catch (error) {
        console.log(error);
        return "N/A-error";
      }
    },
    eliminarReporte: function(idreporte) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el reporte con No. Proceso: " + idreporte + "?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id_reporte: idreporte,
          }
          axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
            .then((res) => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El reporte se eliminó correctamente",
                footer: ""
              });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargarReportes();
              this.cargarReportesPartida();
              this.cargarReportesCoves();
            });
        }
      });
    },
  },
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}
.elevation-1 .v-expansion-panel >>> .v-label.theme--light {
        color: black !important;
    }
.elevation-1 >>> div.v-input.theme--light.v-input--selection-controls.v-input--checkbox div.v-input__control{
    margin-bottom: -35px;
}
.elevation-1 >>> .v-input--has-state > div:nth-child(1) > div:nth-child(2){
    margin-top: -10px;
}
.elevation-1 >>> div.v-input.theme--light.v-input--selection-controls.v-input--checkbox div.v-input__control div.v-input__slot label.v-label.theme--light{
    font-size: 10px !important;
}
.v-card__text  >>> .columnadescripcion {
  white-space: normal !important;
  max-width: 300px !important;
}
.v-card__text  >>> .columnaidentificadores  {
  white-space: normal !important;
  max-width: 450px !important;
}
</style>
